/*
 * File: RegisterForm.tsx
 * Project: a-a
 * File Created: Friday, 11th October 2024 6:34:44 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 11:32:42 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import CustomButton from '../../components/shared/CustomButton/CustomButton';
import zeplinColor from '../../theme/Color';
import CustomTextField from '../../components/shared/CustomTextField/CustomTextField';
import RoutePaths from '../../routes/RoutePaths';
import styles from './RegisterForm.module.css';
import EntryLayoutScreen from '../../components/shared/EntryLayout/EntryLayout';
import { Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { validateEmail, validatePassword } from '../../helper/validate';
import { AuthService } from '../../service/auth.service';
import { useInput } from '../../customHook/useInput';
import validator from 'validator';
import CustomPassword from '../../components/shared/CustomPassword/CustomPassword';

const RegisterForm = () => {
  const user = sessionStorage.getItem('register-user') || '';
  const navigate = useNavigate();
  // const [value,setValue]=useState({
  //     userName:user||'',
  //     password:'',
  //     lastName:'',
  //     firstName:''
  // })
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const {
    handleChange: handleEmailChange,
    handleBlur: handleEmailBlur,
    value: email,
    invalid: invalidEmail,
    didChange: didEmailChange,
  } = useInput(user, validator.isEmail);

  const {
    handleChange: handleFirstChange,
    handleBlur: handleFirstBlur,
    value: firstName,
    invalid: invalidFirstName,
    didChange: didFirstChange,
  } = useInput('', (text) => (validator.isEmpty(text?.trim()) ? false : true));
  // console.log(validator.isEmpty(firstName))
  const {
    handleChange: handleLastChange,
    handleBlur: handleLastBlur,
    value: lastName,
    invalid: invalidLastName,
    didChange: didLastChange,
  } = useInput('', (text) => (validator.isEmpty(text?.trim()) ? false : true));

  const {
    handleChange: handlePasswordChange,
    handleBlur: handlePasswordBlur,
    value: password,
    invalid: invalidPassword,
    didChange: didPasswordChange,
  } = useInput('', (text) => validatePassword(text).valid);

  const [error, setError] = useState(false);
  const valid = !(invalidEmail || invalidFirstName || invalidLastName || invalidPassword);

  // console.log(lastName, firstName, email, password, valid);
  const createUser = async () => {
    try {
      if (valid) {
        const res = await AuthService.register({ userName: email, firstName, lastName, password });
        // console.log(res.httpStatusCode == 200);
        if (res) {
          navigate(RoutePaths.EmailVerification);
        }
      }
    } catch (err) {
      console.log(err);
      setError(true);
    }
  };
  //     const handleChange=(event:React.ChangeEvent<HTMLInputElement>)=>{
  //         console.log(event.target.name,event.target.value)
  //         setValue(prev=>({
  // ...prev,
  // [event.target.name]:event.target.value
  //         }))
  //     }
  const [check, setCheck] = useState<{
    valid: boolean;
    hasLowercase: boolean;
    hasUppercase: boolean;
    hasMinLength: boolean;
    hasSymbol: boolean;
    hasNumber: boolean;
  }>({
    valid: false,
    hasLowercase: false,
    hasUppercase: false,
    hasMinLength: false,
    hasSymbol: false,
    hasNumber: false,
  });
  useEffect(() => {
    // check = validatePassword(password);
    setCheck(validatePassword(password));
  }, [password]);

  console.log(check);
  const children = (
    <div className={styles['register-form-input']}>
      <CustomTextField
        style={{ width: '50%' }}
        onBlur={handleEmailBlur}
        onChange={handleEmailChange}
        name='userName'
        text={email}
        disable={true}
        error={invalidEmail && didEmailChange ? 'Please enter valid email' : ''}
        label='Email address'
        type='email'
        tabindex={1}
      />
      {/* <div className={styles['name-field']}>
        <CustomTextField
          style={{ width: '50%' }}
          onBlur={handleFirstBlur}
          onChange={handleFirstChange}
          name='firstName'
          text={firstName}
          error={invalidFirstName && didFirstChange ? 'Create valid First name' : ''}
          label='First name'
          required={true}
          tabindex={2}
        />
        <CustomTextField
          style={{ width: '50%' }}
          onBlur={handleLastBlur}
          onChange={handleLastChange}
          name='lastName'
          text={lastName}
          error={invalidLastName && didLastChange ? 'Create valid Last name' : ''}
          label='Last name'
          required={true}
          tabindex={3}
        />
      </div> */}
      <div className={styles['name-field']}>
        <div style={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            style={{ width: '100%' }}
            onBlur={handleFirstBlur}
            onChange={handleFirstChange}
            name='firstName'
            text={firstName}
            error={invalidFirstName && didFirstChange ? 'Create valid First name' : ''}
            label='First name'
            required={true}
            tabindex={2}
          />
        </div>
        <div style={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            style={{ width: '100%' }}
            onBlur={handleLastBlur}
            onChange={handleLastChange}
            name='lastName'
            text={lastName}
            error={invalidLastName && didLastChange ? 'Create valid Last name' : ''}
            label='Last name'
            required={true}
            tabindex={3}
          />
        </div>
      </div>
      <CustomPassword
        style={{ width: '50%', margin: 'auto' }}
        showPassword={showPassword}
        handleClickShowPassword={handleClickShowPassword}
        handleMouseDownPassword={handleMouseDownPassword}
        handleMouseUpPassword={handleMouseUpPassword}
        onBlur={handlePasswordBlur}
        onChange={handlePasswordChange}
        name='password'
        text={password}
        error={invalidPassword && didPasswordChange ? 'Create valid password' : ''}
        label='Create password*'
        tabindex={4}
      />
      <div className={styles['password-rule']} style={{ color: zeplinColor.Neutral9 }}>
        <div className={styles['validation-points']}>
          <img
            src={check?.hasMinLength ? '/assets/check.svg' : '/assets/dot.svg'}
            width={20}
            height={20}
          />
          <Typography variant='body3' style={{ color: zeplinColor.Neutral9 }}>
            At least 8 characters
          </Typography>
        </div>
        <div className={styles['validation-points']}>
          <img
            src={check?.hasNumber ? '/assets/check.svg' : '/assets/dot.svg'}
            width={20}
            height={20}
          />
          <Typography variant='body3' style={{ color: zeplinColor.Neutral9 }}>
            At least 1 number
          </Typography>
        </div>
        <div className={styles['validation-points']}>
          <img
            src={
              check?.hasLowercase && check?.hasUppercase ? '/assets/check.svg' : '/assets/dot.svg'
            }
            width={20}
            height={20}
          />
          <Typography variant='body3' style={{ color: zeplinColor.Neutral9 }}>
            At least 1 uppercase & 1 lowercase letter
          </Typography>
        </div>
        <div className={styles['validation-points']}>
          <img
            src={check?.hasSymbol ? '/assets/check.svg' : '/assets/dot.svg'}
            width={20}
            height={20}
          />
          <Typography variant='body3' style={{ color: zeplinColor.Neutral9 }}>
            At least 1 special character
          </Typography>
        </div>
      </div>
      {/* </div> */}
      <CustomButton
        disabled={valid ? false : true}
        onClick={createUser}
        variant='contained'
        color={valid ? 'primary' : 'customDisable'}
        style={{ width: '50%', borderRadius: '14px', height: 56 }}
        textStyle={{ color: valid ? zeplinColor.Neutral1 : zeplinColor.Neutral8 }}
        text={'Create Account'}
        tabindex={5}
      />
      <Typography
        variant='h2'
        style={{
          width: '50%',
          color: zeplinColor.Neutral9,
          textAlign: 'center',
          // marginBottom: '1rem',
          // marginTop: 8,
        }}
      >
        By tapping on create account, you agree to A&A Management{' '}
        <Link to='#' style={{ color: zeplinColor.Brand1, textDecoration: 'none' }}>
          Terms
        </Link>{' '}
        and{' '}
        <Link to='#' style={{ color: zeplinColor.Brand1, textDecoration: 'none' }}>
          Privacy
        </Link>
        .
      </Typography>
    </div>
  );
  const alternative = '';
  return (
    <EntryLayoutScreen
      header={'Create a huddle account'}
      subheader='These are the details that will appear on your profile.'
      input={children}
      alternative={alternative}
      footerText='Already have an account? '
      footerButtonText='Log in'
      path={RoutePaths.Root}
      clickAction={() => {}}
      footer={false}
    />
  );
};

export default RegisterForm;
